/**
 * Maps query parameter keys based on a field map and filters out empty/null/undefined values.
 */
export const mapFilterParams = (
  params: Record<string, any>,
  fieldMap: Record<string, string>,
): Record<string, any> => {
  const mapped: Record<string, any> = {};
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      const mappedKey = fieldMap[key] || key;
      mapped[mappedKey] = val;
    }
  });
  return mapped;
};
